import { api } from '../client';
import type { AccessLog, LogStats } from '../../types/log';

export interface LogsResponse {
  success: boolean;
  logs: AccessLog[];
  page: number;
  perPage: number;
  total: number;
  totalPages: number;
}

export const logsApi = {
  list: (params: { page?: number; per_page?: number; event_type?: string; client_id?: string; search?: string } = {}) =>
    api.get<LogsResponse>('/api/logs', params as Record<string, string | number>),

  stats: (hours = 24) =>
    api.get<{ success: boolean; stats: LogStats }>('/api/logs/stats', { hours }),

  purge: () =>
    api.delete<{ success: boolean; deleted: number }>('/api/logs/old'),

  appLogs: (lines = 100, filter = '') =>
    api.get<{ success: boolean; logs: string[]; total: number }>(
      '/api/app-logs', { lines, ...(filter ? { filter } : {}) }
    ),
};
